import ForumOutlined from '@mui/icons-material/ForumOutlined';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { FeatureFlags } from '~constants/featureFlags';
import { useStores } from '~store';
import { useAwaitableFeatureFlag } from '~utils/hooks/useFeatureFlag';

import QuickFilterChip from './QuickFilterChip';

const UnreadMessagesFilter = observer(() => {
  const { ordersDispatchStore } = useStores();
  // Awaitable, so a saved filter is only dropped once the flag is known to be off (a Split
  // timeout counts as off), never while the treatment is still loading.
  const { isAwaitingTreatment, isFeatureFlagEnabled: isInAppMessagingEnabled } =
    useAwaitableFeatureFlag({ featureFlagKey: FeatureFlags.inAppMessaging });
  const isSelected = ordersDispatchStore.filters.hasUnreadMessages === true;
  const isSavedFilterOrphaned =
    !isAwaitingTreatment && !isInAppMessagingEnabled && isSelected;

  useEffect(() => {
    if (isSavedFilterOrphaned) {
      ordersDispatchStore.setFilters({ hasUnreadMessages: undefined }, true);
    }
  }, [isSavedFilterOrphaned, ordersDispatchStore]);

  if (!isInAppMessagingEnabled) {
    return null;
  }

  const handleClick = () => {
    ordersDispatchStore.setFilters(
      { hasUnreadMessages: isSelected ? undefined : true },
      true,
    );
  };

  return (
    <Box sx={{ ml: 1 }}>
      <QuickFilterChip
        icon={<ForumOutlined />}
        label={t('dispatch.dispatch_v2.filters.unread_messages.chip')}
        onClick={handleClick}
        isSelected={isSelected}
        data-test-id="page-dispatch__unread-messages-filter__button"
      />
    </Box>
  );
});

export default UnreadMessagesFilter;
